<mat-form-field *ngIf="workflowDefinitions && workflowDefinitions.length" appearance="outline" class="w-100">
  <mat-label>{{'WORKFLOW' | translate: {Default: 'Workflow'} }}</mat-label>
  <mat-select placeholder="Select Workflow" name="workflowDefinitionId" #locationIdField="ngModel" [(ngModel)]="workflowDefinition"
    (ngModelChange)="workflowDefChanged($event)" required>
    <mat-option *ngFor="let workflowDefinition of workflowDefinitions" [value]="workflowDefinition">
      {{workflowDefinition.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
